import { formatShortDate } from '@/components/orders/workspaceOrderPresentation'

export const RESTART_ORDER_TITLE = 'Restart Order'
export const RESTART_ORDER_KEEP_LABEL = 'Keep Prior Details'
export const RESTART_ORDER_RESET_LABEL = 'Start Over'

/**
 * Body paragraphs for the Restart Order modal (GEN-6020).
 *
 * The canceller's name is shown only when it was recorded; cancellations from
 * before attribution was tracked show the date alone. The chart note applies to
 * EHR-integrated launches, where patient details are prefilled from the chart.
 */
export function buildRestartOrderCopy(params: {
  cancelledAt?: string | null
  cancelledByName?: string | null
  isIntegratedTenant: boolean
}): string[] {
  const date = params.cancelledAt?.trim() ? formatShortDate(params.cancelledAt) : null
  const by = params.cancelledByName?.trim()

  let canceled = 'This order was canceled.'
  if (date && by) canceled = `This order was canceled on ${date} by ${by}.`
  else if (date) canceled = `This order was canceled on ${date}.`

  const lines = [canceled, 'You can pick up from the details entered in the canceled order, or start over.']
  if (params.isIntegratedTenant) {
    lines.push('Patient information from the chart will carry over either way.')
  }
  return lines
}
